import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import autoLoginOTAUserEAuth from "../services/autoLoginOTAUserEAuth";
import CircularProgress from "@mui/material/CircularProgress";
import { runRedirect } from "../utils/validUrlRedirect";
import { styled, Box } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ButtonCustom from "../components/buttons/Button";
import Title from "../components/text/Title";
import useMediaQuery from '@mui/material/useMediaQuery';
import theme from '../theme/theme';


const ContainerRoot = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  alignContent: "center",
  flexDirection: "column",
  gap: "2rem",
  marginBottom: "5rem",
  overflow:"hidden"
}));


export default ({ urlRedirect }) => {
  const { uuid } = useParams();
  const [loader, setLoader] = useState(true);
  const [validLogin, setValidLogin] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const loginSuccessText = 'El login se generó de manera exitosa.'
  const media = useMediaQuery(theme.breakpoints.down('md'));


  useEffect(() => {
    if (uuid)
      autoLoginOTAUserEAuth(uuid, (state) => {
                
        if (state.status == "INVALID") setErrorMessage("El link ya fue utilizado");
        if (state.status == "ERROR") setErrorMessage("Ocurrió un error interno. Intente más tarde.");  
        
        setLoader(false);

        if (state?.code === 302) {
          setValidLogin(true);
          runRedirect(urlRedirect, { jwt2: state?.message }, "");
        }
      });
  }, []);


  const onHandleAgain = () => {
    window.location.replace(`/autologin/email`);
  }

  return (
    <ContainerRoot>
      {loader && <CircularProgress size={"5rem"} sx={{ color: "#263057" }} />}
      {!loader && (
        <div>
          {validLogin && (
               <Box sx={{ display: "flex", alignItems: "center" }}>
               <CheckCircleIcon fontSize="large" color="success" ></CheckCircleIcon>
               <Box sx={{ marginInline: "-2rem", marginBottom: "-1.3rem" }}>
                 <Title>{loginSuccessText}</Title>
               </Box>
             </Box>
                 

          )}
          {!validLogin && (
            <ContainerRoot>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <ErrorIcon color="error"></ErrorIcon>
              <Box sx={{ marginInline: "-2rem", marginBottom: "-1.3rem" }}>
                <Title>{errorMessage}</Title>
              </Box>
              
            </Box>
            <ButtonCustom
                borderRadius={16}
                width={media ? '50%' : '100%'}
                variant={'contained'}
                color={'white'}
                background={'#263057'}
                onClick={onHandleAgain}
                size="medium"
                label={'INGRESAR EMAIL'}
          
              ></ButtonCustom>
            </ContainerRoot>
          )}
        </div>
      )}
    </ContainerRoot>
  );
};
